module.exports = __webpack_public_path__ + "img/logo_espace_client_ubiflow_en@2x.3fc7249f.png";